/** Specify if the activity event is aggregated, single or none */
export var ActivityEventType;
(function (ActivityEventType) {
    ActivityEventType["SINGLE"] = "single";
    ActivityEventType["AGGREGATED"] = "aggregated";
    // this event type doesn`t send the event to the activity table, only to the error table if there is an error
    ActivityEventType["NONE"] = "none";
})(ActivityEventType || (ActivityEventType = {}));
//# sourceMappingURL=mfsLoggerTypes.js.map